import { render, staticRenderFns } from "./BackgroundEmbedMixin.vue?vue&type=template&id=86ec915a&"
import script from "./BackgroundEmbedMixin.vue?vue&type=script&lang=js&"
export * from "./BackgroundEmbedMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports